import 'promise-polyfill/src/polyfill'
// import svg4everybody from 'svg4everybody'
require('intersection-observer')

// svg4everybody()
